import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomeScreen from './components/HomeScreen.tsx';
import VisitorForm from './components/VisitorForm.tsx';
import QuickLookup from './components/QuickLookup.tsx';
import Admin from './components/Admin.tsx';
import ThankYou from './ThankYou';
import './styles/VisitorForm.css';
import './styles/QuickLookup.css';

function App() {
    return (
      <Routes>
        <Route path="/" element={<HomeScreen />} />
        <Route path="/visitor-sign-in" element={<VisitorForm />} />
        <Route path="/quick-lookup" element={<QuickLookup />} />
        <Route path="/thankyou" element={<ThankYou />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    );
}

export default App;